import createApiMethods from '@/api/createApiMethods';
import initializeAxios from './axiosSetup';
import { axiosPaymentRequestConfiguration } from './config';

export const axiosInstance = initializeAxios(axiosPaymentRequestConfiguration);

const api = createApiMethods(axiosInstance);

export default api;
